import ActionType from './action-type'
import * as Actions from './actions'
import {ErrorOccurred} from '../session-data/action-creators'
import {type AnyAction} from 'redux'
import {type ThunkAction} from 'redux-thunk'
import {UserAgentApplication} from 'msal'

import {Api} from '../../../api/Api'
import {fetchNodes, registerNewAssetDiscoveredQuery} from '../nodes/action-creators'
import {fetchRolesForCurrentUser} from '../roles/action-creators'
import {type AppState} from '../../types/app-state'
import {fetchThreatMeasures} from '../threat-measures/action-creators'
import {fetchLocations, resetActiveLocation} from '../locations/action-creators'
import {registerLatestEventTimestampsQuery} from '../latest-event-timestamps/action-creators'
import {fetchWatchedNodes} from '../watched-nodes/action-creators'
import {fetchCurrentUser} from '../current-user/action-creators'
import {fetchIncidentTypeses} from '../incident-types/action-creators'
import {fetchWatchedIncidents} from '../watched-incidents/action-creators'
import {
    fetchEnforcementNetworksLicense,
    fetchEnforcementRemovablesLicense,
    fetchFleetConfigForIncidentReopenProcessing,
    fetchFleetConfigForNetworkAssets,
    fetchFleetConfigForNmeaInventory,
    fetchFleetConfigForReports,
    fetchFleetConfigForSoftwareInventory,
    fetchFleetConfigForUsbInventory,
    fetchIncidentLicense,
    fetchMetricsOnboardEngagementLicense,
} from '../config/action-creators'
import {fetchAllLocationTagsByLocation} from '../vessel-tags/action-creators'
import {fetchSavedFilters} from '../saved-filters/action-creators'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function logout(msal?: UserAgentApplication): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (dispatch: any, _: any, api: Api): void => {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        dispatch(resetActiveLocation())
        api.logout()

        if (msal) {
            try {
                msal.logout()
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                dispatch(clearMSAL())
            } catch (err) {
                console.error(err)
            }
        }

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        dispatch(clearAuthToken())
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorOccured(error: string): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (dispatch: any, _: any, api: Api): void => {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        dispatch(resetActiveLocation())
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        dispatch(ErrorOccurred(error))
        api.logout()
    }
}

export function authTokenRetrieved(authToken: string): Actions.AuthTokenRetrievedAction {
    return {
        type: ActionType.RECEIVE_AUTH_TOKEN,
        payload: authToken,
    }
}

export function clearAuthToken(): Actions.ClearAuthTokenAction {
    return {
        type: ActionType.CLEAR_AUTH_TOKEN,
    }
}

export function fetchInitialData(): ThunkAction<void, AppState, Api, AnyAction> {
    return (dispatch) => {
        // CDS-6008: the latest per-vessel threat scores now come from
        // warning-and-scoring via useLatestLocationThreatScoresFromWarningAndScoring,
        // mounted in the authenticated shell. The SFM asset scores are gone
        // entirely - warning-and-scoring has no asset-level scoring and the UI
        // areas that showed them have been removed.
        dispatch(registerLatestEventTimestampsQuery())
        dispatch(registerNewAssetDiscoveredQuery())
        dispatch(fetchCurrentUser())
        dispatch(fetchRolesForCurrentUser())
        dispatch(fetchAllLocationTagsByLocation())
        dispatch(fetchNodes())
        dispatch(fetchLocations())
        dispatch(fetchThreatMeasures())
        dispatch(fetchWatchedNodes())
        dispatch(fetchIncidentTypeses())
        dispatch(fetchWatchedIncidents())
        dispatch(fetchFleetConfigForReports())
        dispatch(fetchFleetConfigForNetworkAssets())
        dispatch(fetchFleetConfigForUsbInventory())
        dispatch(fetchFleetConfigForSoftwareInventory())
        dispatch(fetchFleetConfigForNmeaInventory())
        dispatch(fetchFleetConfigForIncidentReopenProcessing())
        dispatch(fetchSavedFilters())
        dispatch(fetchIncidentLicense())
        dispatch(fetchMetricsOnboardEngagementLicense())
        dispatch(fetchEnforcementNetworksLicense())
        dispatch(fetchEnforcementRemovablesLicense())
    }
}

export function setMSAL(msal: UserAgentApplication): Actions.SetMSALAction {
    return {
        type: ActionType.SET_MSAL,
        payload: msal,
    }
}

export function clearMSAL(): Actions.ClearMSALAction {
    return {
        type: ActionType.CLEAR_MSAL,
    }
}
